import { getLocalTimeZone, today } from '@internationalized/date'
import { addMonths, differenceInCalendarMonths, format, getDate, parseISO } from 'date-fns'

import { GerenciadorMensaisBase } from '@/domain/simulador/gerenciador-mensais-base'
import type { TCriarProximoGrupoMensais } from '@/features/simulador/brasil/types'

export class GerenciadorMensaisSacocH extends GerenciadorMensaisBase {
  obterDataFimPrazo(dataInicio: string, quantidadeMensais: number): string {
    const dataLimite = this.clamp(addMonths(parseISO(dataInicio.toString()), quantidadeMensais), 1)
    return format(dataLimite, 'yyyy-MM-dd')
  }

  override criarProximoGrupo({
    quantidadeMensais = 0,
    dataUltimaMensal,
    dataPrimeiraMensal,
  }: TCriarProximoGrupoMensais) {
    const dataMesSubsequente = addMonths(parseISO(dataUltimaMensal ?? today(getLocalTimeZone()).toString()), 1)
    const dataLimite = this.obterDataFimPrazo(
      dataPrimeiraMensal ?? format(dataMesSubsequente, 'yyyy-MM-dd'),
      quantidadeMensais,
    )

    const diaAlvo = dataUltimaMensal ? getDate(parseISO(dataUltimaMensal)) : 10
    const novaDataInicio = format(this.clamp(dataMesSubsequente, diaAlvo), 'yyyy-MM-dd')
    const quantidadeMesesRestantes = differenceInCalendarMonths(parseISO(dataLimite), parseISO(novaDataInicio)) - 1

    const novaDataFim = format(addMonths(parseISO(novaDataInicio), quantidadeMesesRestantes), 'yyyy-MM-dd')
    const isDataFimValid = novaDataFim > novaDataInicio
    return this.criar(novaDataInicio, isDataFimValid ? novaDataFim : novaDataInicio)
  }
}
